var _style, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon2, _polygon3, _rect9, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _polygon5, _polygon6, _polygon7, _polygon8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgreementAajr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_96ecc45-c3c6-4b7d-8685-374129418fe3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 885 857",
    style: {
      enableBackground: "new 0 0 885 857"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:url(#SVGID_00000108277071200838783740000009468660054478353080_);}\n\t.st4{fill:url(#SVGID_00000038377078375327265400000014920336322185784205_);}\n\t.st5{fill:url(#SVGID_00000018959537391923994240000014742231579440623266_);}\n\t.st6{fill:url(#SVGID_00000054972183093675301440000004153921771639433877_);}\n\t.st7{fill:url(#SVGID_00000005946571747729559260000011480723891732289203_);}\n\t.st8{fill:url(#SVGID_00000111907147690828627480000008780872488266191519_);}\n\t.st9{fill:#69F0AE;}\n\t.st10{fill:url(#SVGID_00000086653636383949786120000006716269078665093804_);}\n\t.st11{fill:#E0E0E0;}\n\t.st12{fill:url(#SVGID_00000045608011182802125970000009289045597786852491_);}\n\t.st13{fill:url(#SVGID_00000039091548754139285770000002541336056799215499_);}\n\t.st14{fill:url(#SVGID_00000168800658297665364440000004046053454881195653_);}\n\t.st15{fill:#BE7C5E;}\n\t.st16{fill:#FDA57D;}\n\t.st17{fill:#333333;}\n\t.st18{fill:#FF8206;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 638.8205,
    y1: 96.2706,
    x2: 638.8205,
    y2: 804.4006,
    gradientTransform: "matrix(0.9098 -0.415 -0.415 -0.9098 60.8961 1103.3347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.1,212.7 541.4,0 835.3,644.3 369,857  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 79.9,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -135.8908 226.8952)",
    className: "st2",
    width: 499.5,
    height: 692.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170980500232975659940000009784945765148242090_",
    gradientUnits: "userSpaceOnUse",
    x1: 639.4855,
    y1: 757.4506,
    x2: 639.4855,
    y2: 817.4706,
    gradientTransform: "matrix(0.9098 -0.415 -0.415 -0.9098 60.8843 1103.3307)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000170980500232975659940000009784945765148242090_)"
    },
    points: "190.7,145.6 416.2,42.8  441.1,97.4 215.6,200.2 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020385335714982785370000012486700067911539607_",
    gradientUnits: "userSpaceOnUse",
    x1: 639.4849,
    y1: 805.2076,
    x2: 639.4849,
    y2: 876.136,
    gradientTransform: "matrix(0.9098 -0.415 -0.415 -0.9098 60.8841 1103.3352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020385335714982785370000012486700067911539607_)"
    },
    d: "M279.1,40.8c-17.4,7.9-24.9,28.8-16.8,46.6 s28.8,25.8,46.2,17.9s24.9-28.8,16.8-46.6S296.5,32.9,279.1,40.8z M302.3,91.7c-10.2,4.9-22.4,0.7-27.4-9.5s-0.7-22.4,9.5-27.4 c10.2-4.9,22.4-0.7,27.4,9.5c0.1,0.1,0.1,0.3,0.2,0.4C316.7,74.9,312.4,87,302.3,91.7C302.3,91.7,302.3,91.7,302.3,91.7L302.3,91.7z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086653359706429176460000011292908892780464520_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.1079,
    y1: 120.3323,
    x2: 437.6063,
    y2: 120.3323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000086653359706429176460000011292908892780464520_)"
    },
    points: "193.1,144.6 413.8,43.9  437.6,96.1 216.9,196.8 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063633847949826725490000012947654767199846051_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.3203,
    y1: 74.0539,
    x2: 328.1568,
    y2: 74.0539
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063633847949826725490000012947654767199846051_)"
    },
    d: "M280.2,43.2c-17,7.8-24.6,27.9-16.8,44.9 s27.9,24.6,44.9,16.8c17-7.8,24.6-27.9,16.8-44.9c0,0,0,0,0,0C317.3,42.9,297.2,35.4,280.2,43.2z M302.4,91.9 c-9.8,4.5-21.4,0.1-25.9-9.7s-0.1-21.4,9.7-25.9c9.8-4.5,21.4-0.1,25.9,9.7C316.5,75.8,312.2,87.4,302.4,91.9L302.4,91.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050642257632416643990000004853828640236877473_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.0355,
    y1: 580.0906,
    x2: 466.0355,
    y2: 687.0306,
    gradientTransform: "matrix(0.9098 -0.415 -0.415 -0.9098 60.8892 1103.3385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000050642257632416643990000004853828640236877473_)"
    },
    points: "151.1,307 248.4,262.7 292.8,360  195.5,404.3 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083048026918291150780000004731894445488507807_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.3955,
    y1: 368.1706,
    x2: 466.3955,
    y2: 475.1106,
    gradientTransform: "matrix(0.9098 -0.415 -0.415 -0.9098 60.893 1103.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000083048026918291150780000004731894445488507807_)"
    },
    points: "239.4,499.7 336.7,455.3  381.1,552.6 283.8,597 "
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 283.9,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -118.3904 122.1901)",
    className: "st9",
    width: 99.1,
    height: 99.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057138313301839814770000008818872770961482886_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.4397,
    y1: 524.5214,
    x2: 374.7433,
    y2: 524.5214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057138313301839814770000008818872770961482886_)"
    },
    points: "243.4,500 333.6,458.9 374.7,549  284.6,590.2 "
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 314.3,
    y: 240,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -67.1006 180.7159)",
    className: "st11",
    width: 135.9,
    height: 9.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 234.6,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -60.6894 199.3797)",
    className: "st11",
    width: 224.3,
    height: 9.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322.9,
    y: 250.8,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -67.535 200.3039)",
    className: "st11",
    width: 208.5,
    height: 9.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 401.5,
    y: 431,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -138.5207 234.1079)",
    className: "st11",
    width: 135.8,
    height: 9.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 403.4,
    y: 425.6,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -132.106 252.7692)",
    className: "st11",
    width: 224.3,
    height: 9.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 441.8,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -138.9551 253.6959)",
    className: "st11",
    width: 208.5,
    height: 9.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062899146859551400580000003566737348214672039_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.0349,
    y1: 607.9728,
    x2: 466.0349,
    y2: 660.4663,
    gradientTransform: "matrix(0.9098 -0.415 -0.415 -0.9098 60.8941 1103.3352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062899146859551400580000003566737348214672039_)"
    },
    points: "199,337.5 222.3,345 229.9,300.3  241.2,303.4 228.5,358.6 193.5,343.3 "
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "202,336.9 222.2,343.4 228.8,304.6 238.6,307.2 227.6,355.3 197.1,342 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "289.7,529.1 309.9,535.6 316.5,496.8 326.3,499.5 315.3,547.5 284.8,534.2 "
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 594.6,
    transform: "matrix(0.9098 -0.415 0.415 0.9098 -218.6195 288.7431)",
    className: "st11",
    width: 316.9,
    height: 105.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093135817948484738330000008063241680874365094_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.4232,
    y1: 655.8669,
    x2: 637.8687,
    y2: 655.8669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093135817948484738330000008063241680874365094_)"
    },
    d: "M635.5,610.2c-11.1-3.2-22.4-2.6-26,10.1 c-1.2,4.3-1.3,10.9-5.9,13.1c-6.7,3.2-14.9-3.2-20.7-5.9c-10.9-4.9-22.1-1.6-28.4,8.8c-3.2,5.2-4.6,11.3-5.7,17.2 c-0.5,2.6-0.5,5.8-1.6,8.2c-2.1,4.7-8.6,4.2-12.9,4.1c-0.9,0-1.9-0.1-2.9-0.2c3.4-4.7,5.1-10.4,4.8-16.1 c-0.3-9.5-6.4-19.8-17.2-18.7c-9.6,1-16.4,10.3-15.3,19.7c0.9,8,6.1,14.2,12.8,18c-3.3,1.5-6.8,2.6-9.9,4.1 c-1.4,0.7-2.9,1.5-4.2,2.3c-9.4-4.5-21.7-5.4-30.1-0.8c-4.1,2.2-1.1,8.9,3,6.6c6.4-3.5,13.5-2.6,20.2-0.4l0.6,0.2 c-0.7,0.8-1.2,1.8-1.8,2.7c-3.8,7.4,0,19,9.2,19.8c13,1.1,13.6-16.1,6.5-22.9c-0.3-0.3-0.6-0.6-0.9-0.8c2.9-1.4,6.1-2.5,8.9-3.7 c2.4-1,4.7-2.3,6.9-3.8l0.5,0.1c9.9,2.2,25.4,3,29-9.1c3.1-10.4,3.3-32.6,19.8-30.6c6.7,0.8,12.2,6,18.7,7.9 c5.7,1.7,12.4,1.8,17.1-2.4c3.9-3.5,4.8-8.6,5.9-13.4c0.6-2.5,1.2-5.4,3.2-7.2c3.7-3.2,9.7-1.3,13.8-0.2 C637.4,618.3,640,611.5,635.5,610.2z M506.5,694.8c-2.2,2.2-4.5,0.5-5.7-1.8c-1.4-2.8-0.8-5.5,1-7.9c0.3-0.4,0.6-0.8,1-1.1 C507.1,686.7,510.7,690.7,506.5,694.8L506.5,694.8z M514.2,640.8c4.5-4.2,10.8-3.3,13.5,2.5s1.5,13.8-2.3,18.9 c-0.5,0.7-1.1,1.3-1.7,1.9c-2.6-0.9-5-2.3-7.1-4.1C511.3,655.1,508.3,646.3,514.2,640.8L514.2,640.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133513336183233248560000014874195401102791870_",
    gradientUnits: "userSpaceOnUse",
    x1: 599.595,
    y1: 248.8895,
    x2: 599.595,
    y2: 755.22,
    gradientTransform: "matrix(1 0 0 -1 -157.12 835.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133513336183233248560000014874195401102791870_)"
    },
    d: "M695.5,221.7l-80.7,31.5 c-15.2-1.1-47.1-5.2-78.8-20.2c-35.3-16.6-75.7-16.6-110,0.8c-79,1.9-122.5-8.2-145.7-17.8l6.1-12.6l-81.8-31.9L0,79.9v375.8 l71.6,31.9l38.4-92.1l84.3,39l16.2-41.1l55.4,41.1l3.8,3.2l-5.2,5.4c-9.9,10.4-9.9,26.8,0,37.2l0,0c9.4,9.9,24.9,10.3,34.8,1 c0.3-0.3,0.7-0.6,1-1l-2.8,3c-9.9,10.4-9.9,26.8,0,37.2l0,0c9.4,9.9,24.9,10.3,34.8,1c0.3-0.3,0.7-0.6,1-1l16.4-17.1l0,0L338.4,515 c-9.9,10.4-9.9,26.8,0,37.2l0,0c9.4,9.9,24.9,10.3,34.8,1c0.3-0.3,0.7-0.6,1-1l16.2-16.8l0,0l-6.8,7.1c-6.9,7.3-6.9,18.7,0,26 c6.5,6.9,17.4,7.2,24.3,0.7c0.2-0.2,0.5-0.4,0.7-0.7l10.8-11.2c18.5,13.5,33.6,23.4,40.9,26c30.6,10.6,30.6-10.7,30.6-10.7 c40.9,21.3,61.4-21.3,61.4-21.3c51.1,21.3,51.1-31.9,51.1-31.9c12.8,8.9,22,4.8,28.4-3c8.8-10.6,9.8-25.5,3.8-37.5l48.9-45.2 l21.1,43.2l84.3-39l38.4,85.1l56.5-25.3V126L695.5,221.7z"
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "681.9,418.5 592.9,497.6 523.7,369 681.9,329.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M256.6,210.8c0,0,28.6,39.6,197.8,29.7l98.9,148.4l66.3,74.6c10.4,11.7,11,29.5,0.8,41.4 c-6.2,7.2-15.1,11-27.5,2.8c0,0,0,49.5-49.5,29.7c0,0-19.8,39.6-59.3,19.8c0,0,0,19.8-29.7,9.9S266.5,428.4,266.5,428.4l-69.2-49.5 L256.6,210.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M612.7,260.2c0,0-42.7,0-85-19.2c-38.4-17.4-83.2-15.2-118.6,7.7c-28.9,18.6-53.9,49.5-53.5,100.5 c0,0,38.5,39.6,79.1-39.6h29.7c0,0,28.6,98.9,108.8,89s98.9-19.8,98.9-19.8L612.7,260.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M349.8,452.3l3.2,3.2c8.7,8.7,8.7,22.7,0,31.4l-23,23c-8.7,8.7-22.7,8.7-31.4,0l-3.2-3.2 c-8.7-8.7-8.7-22.7,0-31.4l23-23C327.1,443.6,341.1,443.6,349.8,452.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M317.9,415l3.2,3.2c8.7,8.7,8.7,22.7,0,31.4l-23,23c-8.7,8.7-22.7,8.7-31.4,0l-3.2-3.2 c-8.7-8.7-8.7-22.7,0-31.4l23-23C295.2,406.3,309.2,406.3,317.9,415z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M394.3,477l3.2,3.2c8.7,8.7,8.7,22.7,0,31.4l-27.9,27.9c-8.7,8.7-22.7,8.7-31.4,0l-3.2-3.2 c-8.7-8.7-8.7-22.7,0-31.4l27.9-27.9C371.6,468.4,385.6,468.4,394.3,477z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M418.7,512.4l2.2,2.2c6.1,6.1,6.1,15.9,0,21.9l-17.6,17.6c-6.1,6.1-15.9,6.1-21.9,0l-2.2-2.2 c-6.1-6.1-6.1-15.9,0-21.9l17.6-17.6C402.8,506.4,412.6,506.4,418.7,512.4z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "780.8,438.3 691.8,477.8 602.8,260.2 681.9,230.6 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "108.2,388.8 197.3,428.4 286.3,210.8 207.1,181.1 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "9.3,92.1 207.1,181.1 78.6,477.8 9.3,448.1 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "879.7,141.5 681.9,230.6 810.5,527.3 879.7,497.6 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementAajr);
export default __webpack_public_path__ + "static/media/agreement_aajr.effb7acd66d30c8add3fbddfd00f3072.svg";
export { ForwardRef as ReactComponent };